import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { pluck } from '../../../../helpers/utils';
import { ScTableColumn } from '../../../../models/table.model';

@Pipe({
  name: 'valueParser'
})
export class ValueParserPipe implements PipeTransform {
  constructor(private _currency: CurrencyPipe) {}
  transform(value: any, col: ScTableColumn): string {
    const { prop, currency } = col;
    let currencyVal = '';

    if (currency) {
      currencyVal = pluck(value, currency);
      if (!currencyVal) {
        currencyVal = currency; // in case its hardcoded;
      }
    }

    const colValue = typeof prop === 'function' ? prop(value) : pluck(value, prop);

    return currencyVal ? this._currency.transform(colValue, currencyVal) : colValue;
  }
}
